import { Component, OnInit } from '@angular/core';
import { DashboardService } from '../../../services/dashboard.service';
import {CommonHelper} from "../../../shared/helpers/CommonHelper";

interface DataObject {
    _id: String;
    count: number
}

interface DashboardData {
    confidentialityTerm: DataObject[]
    contract: DataObject[]
    irregularPJ: DataObject[]
    inactivatedConsultants: DataObject[]
    borrowedInvoice: DataObject[]
}

@Component({
  selector: 'app-dashboard-judiciary',
  templateUrl: './dashboard-judiciary.component.html',
  styleUrls: ['./dashboard-judiciary.component.scss']
})

export class DashboardJudiciaryComponent implements OnInit {
    loading : boolean = true
    yearList: number[]
    selectedYear: string = new Date().getFullYear().toString()
    monthList: object[]
    selectedMonth: string = '0'
    dashboardData: DashboardData
    chartConfigs: object
    chartData: object = {}
    colors = ['#3566ca', '#990697', '#09951d', '#fe980f', '#db3813','#f0c93e','magenta','gray','pink','black']

  constructor(private dashboardService:DashboardService,
              private commonHelper:CommonHelper,
              ) { }

    async ngOnInit() {
        this.yearList = this.commonHelper.listLastYears(new Date().getFullYear());
        this.monthList = this.commonHelper.listAllMonths();
        this.initChartConfigs()
        await this.search()
        this.loading = false        
  }

    async search(){
        this.loading = true
        this.dashboardData = await this.dashboardService.getJudiciaryData(this.selectedYear, this.selectedMonth)
        this.mapChartData()
        this.loading = false
    }

    mapCountToChart(data: DataObject[]) {
        return data.map(({count}) => count)
    }

    mapHoverLabelToChart(data: DataObject[]) {
        return data.map(({_id}) => _id)
    }

    mapLabelToChart(data: DataObject[]) {
        return data.map(({_id, count}, index) => ({label:_id, color:this.colors[index], data: count}))
    }

    mapTotalToChart(data: DataObject[]) {
        return data.reduce((acc, currentValue) => acc += currentValue.count, 0)
    }

    mapChartData() {
        const dataKeys = Object.keys(this.dashboardData)
        for (const key of dataKeys) {
            this.chartData[key] = {
                data: this.mapCountToChart(this.dashboardData[key]),
                hoverLabels: this.mapHoverLabelToChart(this.dashboardData[key]),
                labels: this.mapLabelToChart(this.dashboardData[key]),
                total: this.mapTotalToChart(this.dashboardData[key])
            }
        }
    }

    initChartConfigs() {
        this.chartConfigs = {
            lineChartOptions: {
                maintainAspectRatio: false,
                legend: { display: false } 
            },
            chartColors: [
                {
                    backgroundColor: this.colors
                }
            ],
            type: 'doughnut'
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/views/dashboard/dashboard-judiciary/dashboard-judiciary.component.ts